import React, { useState } from "react";
import { testimonialsData } from "../data/mock";
import { Card, CardContent } from "./ui/card";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { Button } from "./ui/button";

export const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const next = () =>
    setActiveIndex((prev) =>
      prev === testimonialsData.length - 1 ? 0 : prev + 1
    );
  const prev = () =>
    setActiveIndex((prev) =>
      prev === 0 ? testimonialsData.length - 1 : prev - 1
    );

  return (
    <section id="testimonials" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-50 rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 rounded-full bg-amber-500" />
            <span className="text-amber-700 text-sm font-semibold uppercase tracking-wider">
              Client Reviews
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Hear from our satisfied clients across various industries in Tamil Nadu.
          </p>
        </div>

        {/* Testimonials Display */}
        <div className="max-w-4xl mx-auto">
          {/* Featured Testimonial */}
          <Card className="border-0 bg-emerald-50/50 shadow-none rounded-3xl mb-8">
            <CardContent className="p-10 md:p-14">
              <Quote className="w-10 h-10 text-emerald-200 mb-6" />
              <p className="text-xl md:text-2xl text-slate-700 leading-relaxed font-medium mb-10">
                "{testimonialsData[activeIndex].review}"
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <Avatar className="w-14 h-14 bg-emerald-200">
                    <AvatarFallback className="bg-emerald-700 text-white text-lg font-bold">
                      {testimonialsData[activeIndex].name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <div className="font-bold text-slate-900 text-lg">
                      {testimonialsData[activeIndex].name}
                    </div>
                    <div className="text-slate-500 text-sm">
                      {testimonialsData[activeIndex].role},{" "}
                      {testimonialsData[activeIndex].company}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  {Array.from(
                    { length: testimonialsData[activeIndex].rating },
                    (_, j) => (
                      <Star
                        key={j}
                        className="w-5 h-5 text-amber-400 fill-amber-400"
                      />
                    )
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4">
            <Button
              variant="outline"
              size="icon"
              onClick={prev}
              className="rounded-full border-slate-200 hover:bg-emerald-50 hover:border-emerald-200 w-11 h-11"
            >
              <ChevronLeft className="w-5 h-5" />
            </Button>
            <div className="flex items-center gap-2">
              {testimonialsData.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveIndex(i)}
                  className={`rounded-full transition-all duration-300 ${
                    i === activeIndex
                      ? "w-8 h-2.5 bg-emerald-700"
                      : "w-2.5 h-2.5 bg-slate-300 hover:bg-slate-400"
                  }`}
                />
              ))}
            </div>
            <Button
              variant="outline"
              size="icon"
              onClick={next}
              className="rounded-full border-slate-200 hover:bg-emerald-50 hover:border-emerald-200 w-11 h-11"
            >
              <ChevronRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
